import { createContext } from 'react';
const authtoken = createContext('');

export default authtoken